import BazaarVoiceScript from '@/components/BazaarVoice/Script';
import { init, tagManagerArgs } from '@/config';
import { LightsProvider } from '@/contexts/lightContext';
import theme from '@/theme';
import GlobalStyle from '@/theme/GlobalStyle';
import { GoogleTagManager } from '@next/third-parties/google';
import {
  EcomContextProvider,
  ErrorBoundary,
  NotificationsContextProvider,
} from '@thisisdevelopment/akzonobel-core';
import { ContainerFull, Footer, Topbar } from '@thisisdevelopment/heritage-core-library';
import { AppProps } from 'next/app';
import styled, { ThemeProvider } from 'styled-components';
import '@/styles/global.css';

init();

const AppStyled = styled.div`
  min-height: 100vh;
  display: grid;
  grid-template-rows: 1fr auto;
`;

function App({ Component, pageProps }: AppProps) {
  return (
    <ErrorBoundary>
      <BazaarVoiceScript />
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <NotificationsContextProvider>
          <EcomContextProvider>
            <LightsProvider>
              <Topbar />
              <ContainerFull>
                <AppStyled>
                  <Component {...pageProps} />
                  {process.env.NODE_ENV === 'production' && (
                    <GoogleTagManager gtmId={tagManagerArgs.gtmId} />
                  )}
                  <Footer />
                </AppStyled>
              </ContainerFull>
            </LightsProvider>
          </EcomContextProvider>
        </NotificationsContextProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
